export { default as LandingPage } from './LandingPage';
export { default as DashboardPage } from './DashboardPage';
export { default as TestPage } from './TestPage';
export { default as ResultsPage } from './ResultsPage';
